<template>
  <modal
    v-model="showModal"
    @hide="handleCancel"
  >
    <div slot="header" class="modal-header-custom">
      <div class="header-content">
        <span class="material-icons-round">info_outline</span>
        <h4>Proceed with Save to Library?</h4>
      </div>
      <button
        type="button"
        class="close"
        @click="handleCancel"
        aria-label="Close"
      >
        <span class="material-icons-round">close</span>
      </button>
    </div>
    <div class="iod-confirmation-modal">
      <div class="modal-body-custom">
        <p class="warning-text">
          After saving this statement, you will still be able to make manual edits, but you will
          <strong>not</strong> be able to make updates to the <strong>Disability</strong>,
          <strong>Subjects</strong>, or <strong>Impacted Areas</strong>. Do you still want to save this statement?
        </p>
      </div>
    </div>
    <div slot="footer" class="modal-footer-custom">
      <button
        type="button"
        class="btn btn-default btn-lg"
        @click="handleCancel"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-success btn-lg"
        @click="handleConfirm"
      >
        Save to {{ folderName }}
      </button>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'SaveIODConfirmationModal',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    folderName: {
      type: String,
      required: true
    }
  },
  computed: {
    showModal: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
      this.showModal = false
    },
    handleConfirm() {
      this.$emit('confirm')
      this.showModal = false
    }
  }
}
</script>

<style scoped lang="less">
.modal-header-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  h4 {
    margin: 0;
  }
}

/deep/ .modal-header {
    padding: 12px 20px 12px 20px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.close {
  opacity: 1;
  background: transparent;
  padding: 4px;
  line-height: 1;
  .material-icons-round {
    font-size: 16px;
    color: #6F6F6F;
  }
  &:hover {
    background: #F5F5F5;
    border-radius: 9999px;
  }
}

.warning-text {
    padding: 5px;
    color: #6F6F6F;
}

.btn-lg {
    border-radius: 4px;
}

.btn-success {
  &:hover, &:focus {
    background-color: var(--green-button-hover);
  }
  &:focus {
    outline: solid 2px var(--green-button-hover);
    outline-offset: 2px;
  }
}
/deep/ .modal-footer {
    padding: 16px 20px;
}
</style>
